import { useMutation, useQuery } from '@tanstack/react-query';
import { UserData } from '@stores';
import api from '@api/http/api';

export function useOAuthMutation() {
  return useMutation<
    { notFound?: boolean; username?: string; success: boolean; jwt?: string },
    {},
    { type: 'google' | 'apple'; code: string; }
  >({
    mutationFn: (values) => api.post('/users/oauth', values),
  });
}

export function useChangeAvatarMutation() {
  return useMutation<
    { success: true },
    { success: false },
    { avatar: string }
  >({
    mutationFn: (values) => api.post('/users/avatar', values),
  });
}

export function useCompleteTutorialMutation() {
  return useMutation<{ success: true }, {}, { tutorial: string }>({
    mutationFn: (values) => api.post('/users/complete-tutorial', values),
  });
}

export function useUnblockUserMutation() {
  return useMutation<
    { success: true },
    {},
    { id: string }
  >({
    mutationFn: (values) => api.post('/users/unblock', values),
  });
}

export function useReportUserMutation() {
  return useMutation<
    { success: true },
    {},
    { id: string }
  >({
    mutationFn: (values) => api.post('/users/report', values),
  });
}

export function useBlockUserMutation() {
  return useMutation<
    { success: true },
    {},
    { id: string }
  >({
    mutationFn: (values) => api.post('/users/block', values),
  });
}

export function useBlockedQuery() {
  return useQuery<{ username: string; id: string; }[]>({
    queryFn: () => api.get('/users/blocked'),
    queryKey: ['blocked'],
  });
}

export function useUserInfoQuery(id: string) {
  return useQuery<UserData>({
    queryFn: () => api.get(`/users/info/${id}`),
    queryKey: ['user', id],
  });
}

export function useRestartTutorialMutation() {
  return useMutation<{ success: true }>({
    mutationFn: () => api.post('/users/restart-tutorial'),
  });
}

export function useDeleteAccountMutation() {
  return useMutation<{ success: true }>({
    mutationFn: () => api.post('/users/delete-account'),
  });
}

export function useUserQuery() {
  return useQuery<UserData>({
    queryFn: () => api.get('/users/me'),
    queryKey: ['user'],
  });
}